import React, {
    useEffect,
    useState,
} from 'react';
import { List } from '@material-ui/core';
import 'firebase/firestore';
import UpNextSection from "../../../Common/Views/UpNextSection";
import {CourseViewController} from "./CourseViewController";
import RefreshButtonView from "../../Dashboard/Views/RefreshButtonView";
import styled from "styled-components";
import Course from "../../../Common/Models/Course";
import PlannerFeaturedLinksView from "../Views/PlannerFeaturedLinksView";
import CourseListView from "../Views/CourseListView";
import refreshData from "../../../Common/Helper/refreshData";
import {useAuthState} from "react-firebase-hooks/auth";
import Firebase from "firebase";
import useSnackBar from "../../../Common/Context/Consumers/useSnackBar";

const Container = styled(List)`
  height: auto;
  width: 100%;
  background: white;
  padding: 16px !important;
`;

export const PlannerViewController = (props: any) => {
    //TODO :: CHECK WHY THIS RUNS 2X, CAUSING ANALYTICS TO APPEAR 2X.
    // this is the page for planner tab on menu
   // Firebase.analytics().logEvent('test', { page_location:  '/Planner'});
    const {
        upNext,
        resetUpNext,
    } = props;
    const [selectedCourse, selectCourse] = useState<Course | undefined>(upNext);
    const [user] = useAuthState(Firebase.auth());
    const snackbarContext: any = useSnackBar();

    // should only occur once
    useEffect(() => {
        //Firebase.analytics().logEvent('Planner', { page_location:  '/Dashboard/Planner '});
    }, [])

    const onSelectCourse = (course: Course) => {
        selectCourse(course)
    }

    const reload = async () =>  {
        const refreshTypes = ["Courses"]

        try {
            const resp = await refreshData(user.uid, refreshTypes);

            snackbarContext.setSnackBarInfo({
                status: true,
                type: resp == undefined ? 'success' : 'error',
                message: resp == undefined ? 'Success' : resp.error
            })

        } catch (error) {

        }
    };

    return (
        <>
            <Container
                disablePadding>
                    <UpNextSection disableGutters={false} onClick={onSelectCourse} />
                    <PlannerFeaturedLinksView />
                    <CourseListView onClick={onSelectCourse} />
                    <RefreshButtonView onClick={reload} />
            </Container>

            <CourseViewController
                open={!!selectedCourse}
                course={selectedCourse}
                dismiss={() =>
                    {
                        selectCourse(undefined)
                        if (upNext) {
                            resetUpNext(undefined)
                        }
                    }
                }
            />

        </>
    );
};